module.exports = __webpack_public_path__ + "img/product_89.ab5ea71.webp";